import React from 'react'

import { ListOrdered } from '@cash-design-system/react'
import { ListOrderedVariant } from '@cash-web/protos/squareup/cash/ui/arcade/elements/ListOrdered.pb'
import { FormBlockerElementListOrderedElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

/**
 * A vertical list of rows matching the Arcade list-ordered component
 * https://www.figma.com/design/fu8vNWffYkGUMyznuQyzhc/02-Arcade---Mobile?node-id=73280-128556&t=Gnc0ShWooMnq7Kld-0
 */
export function ListOrderedElement(props: FormBlockerElementListOrderedElement): React.ReactElement | null {
  const type = props.list?.variant === ListOrderedVariant.SUBTLE ? 'subtle' : 'standard'

  const items =
    props.list?.items?.map(item => ({
      label: item.label?.translated_value ?? '',
      body: item.body?.translated_value,
    })) ?? []

  if (items.length === 0) {
    logger.warn(new Error('ListOrderedElement received empty items array'))
    return null
  }

  return <ListOrdered type={type} items={items} />
}
